export default __webpack_public_path__ + "static/media/404.f1b5ef4b.jpg";